import { plainToInstance } from 'class-transformer'
import { Guid } from 'guid-typescript'

import { FileType, MediaFileStatus, MessageAttachment } from '../types'

export class BaseMediaFileData {
  type!: FileType

  name = ''

  file: string | null = null

  guid = Guid.create().toString()

  getModel(): MessageAttachment {
    return plainToInstance(MessageAttachment, { file: this.file, type: this.type })
  }
}

export class CustomMediaFileData extends BaseMediaFileData {
  icon = ''

  constructor() {
    super();
  }

  get fileName() {
    return this.file
  }

  get exactType() {
    return this.type.toString()
  }
}

export class MediaFileData extends BaseMediaFileData {
  progress = 0
  status!: MediaFileStatus

  /**
   * Функтор предназначенный для обрывания отправки файла на сервер, если файл удаляет из списка в процессе отправки его на сервер.
   * Функтор автоматически удаляется при смене статуса атачмента на success в методе setStatus
   * */
  abort?: () => void

  constructor(attachment: MessageAttachment | { file: File, type: FileType }, abortRequest?: () => void) {
    super()

    if (abortRequest) {
      this.abort = abortRequest
    }

    if (attachment instanceof MessageAttachment) {
      this.name = attachment.type
      this.type = attachment.type

      this.file = attachment.file

      this.status = MediaFileStatus.success
      this.progress = 100
    } else {
      this.name = attachment?.file?.name ?? ''
      this.type = attachment.type

      this.status = MediaFileStatus.loading
    }
  }

  setFile(file: string): void {
    this.file = file
  }

  setProgress(val: number): void {
    this.progress = val
  }

  setStatus(status: MediaFileStatus): void {
    this.status = status

    if (status === MediaFileStatus.success) {
      delete this.abort
    }
  }

}
